import { render } from "./region.component.vue?vue&type=template&id=05b0fc18&scoped=true"
import script from "./region.component.vue?vue&type=script&lang=js"
export * from "./region.component.vue?vue&type=script&lang=js"

import "./region.component.vue?vue&type=style&index=0&id=05b0fc18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05b0fc18"

export default script